import React from 'react';
import { Typography, Box, useTheme } from '@mui/material';
import { CustomSelect } from '../Leaderboard.styles';
// interface that accepts a label, value, onChange, options
interface LeaderboardFilterSelectProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  //   options: array of objects with value and label
  options: { value: string; label: string }[];
  disabled?: boolean;
}

const LeaderboardFilterSelect = ({
  label,
  value,
  onChange,
  options,
  disabled,
}: LeaderboardFilterSelectProps) => {
  const theme = useTheme();

  return (
    <Box style={{ display: 'flex', flex: 1, flexDirection: 'column', gap: 6 }}>
      <Typography
        style={{ fontSize: 16, fontWeight: 600, color: theme.custom.text }}
      >
        {label}
      </Typography>
      <CustomSelect onChange={onChange} value={value} disabled={disabled}>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </CustomSelect>
    </Box>
  );
};

export default LeaderboardFilterSelect;
